import {LeasingRateMatrixCell} from '@dms/api/vehicle';

import {LeasingCellCoordinates} from '../types/LeasingCellCoordinates';
import {isSameLeasingCell} from './isSameLeasingCell';

export function findLeasingCell(
  cells: LeasingRateMatrixCell[],
  coordinates: LeasingCellCoordinates
) {
  return cells.find((cell) => isSameLeasingCell(cell, coordinates)) ?? null;
}
